import { Component, OnInit, OnDestroy } from '@angular/core';
import { StateComponent } from '../state-component.interface';
import { Usdm2Service } from '../../../../services/ai/usdm2.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-schedule-of-activities',
  imports: [],
  templateUrl: './schedule-of-activities.component.html',
  styleUrl: './schedule-of-activities.component.css'
})
export class ScheduleOfActivitiesComponent implements StateComponent, OnInit, OnDestroy {
  stateName = 'Schedule Of Activities';
  private usdmSub: Subscription | null = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any = null;

  constructor(private usdm: Usdm2Service) { }

  ngOnInit(): void {
    this.usdmSub = this.usdm.contentUpdate$.subscribe((item) => {
      if (this.usdm.currentState() == this.stateName && item && item.type === 'OsbUploadResponse') {
        if (item.message.includes('All schedule mappings uploaded successfully')) {
          this.data = item.data;
          this.usdm.signalStateCompletion(this.stateName);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.usdmSub?.unsubscribe();
    this.usdmSub = null;
  }

}
